import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-233">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40" data-id="element-234">
          <motion.button onClick={scrollToPricing} animate={{
        boxShadow: ['0 0 12px #d4a85340', '0 0 24px #d4a85370', '0 0 12px #d4a85340']
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="flex items-center gap-2 bg-gold-400 hover:bg-gold-500 text-navy-900 font-bold text-sm px-6 py-3 rounded-full shadow-xl transition-colors duration-200 whitespace-nowrap" data-id="element-235">
            Get it for $6.36 <ArrowDown className="w-4 h-4" data-id="element-236" />
          </motion.button>
        </motion.div>}
    </AnimatePresence>;
}